import React from 'react';
import ReactGA from 'react-ga';
import imgUrl from '../../assets/gie-logo-bg-3.jpg';
import GIEList from '../../components/GIEList/GIEList';
import TitleListScreen from '../../components/TitleListeScreen/TitleListScreen';
import InterventionController from '../../controller/intervention.controller';
import {DateUtil} from '../../util/date-util';
import userInformations from '../../userInformation/user_informations';
import GIEServicesContainer from "../../components/GIEServicesContainer/GIEServicesContainer";
import NoticeForList from "../../components/GIEList/NoticeForList";

export default class MyWorkOrderForm extends React.Component<any, any> {
    interventionController: InterventionController = new InterventionController();

    constructor(props) {
        super(props);
        this.state = {
            data: []
        }
    }

    componentDidMount() {
        ReactGA.pageview(window.location.pathname + window.location.search);
        this.getWorkOrderList();
    }

    getWorkOrderList = () => {
        const noContract = userInformations.getNoContract();
        if (!noContract.length) {
            window.location.href = "/admin/login"
        } else {
            this.getData()
        }
    }

    getData = () => {
        this.interventionController.getInterventionsList().then((data: any) => {
            this.manageData(data);
        }).catch(err => {
            console.log(err)
        })
    }

    manageData = data => {
        const interventionList = data.map(line => {
            return {
                _id: line._id,
                number: line.no ? line.no : '',
                title: line.description ? line.description : '',
                date: line.startingDate ? DateUtil.convertDateInString(new Date(line.startingDate)) : '',
                amount: line.amount ? line.amount : '',
                customerNo: line.customerNo,
                downloadType: "1",
                paid: true,
                visible: line.pdfExist
            }
        })
        this.setState({data: interventionList})
    }

    render() {
        return (
          <div className="content">
              <GIEServicesContainer imgUrl={imgUrl} title={<TitleListScreen miniTitle="Mes documents"
                                                                            href="documents"
                                                                            thirdHref="mes-fiches-d-intervention"
                                                                            title="Mes fiches d'intervention"/>}>
                  <div className="container-xl mb-5">
                      <NoticeForList text="Seuls les documents marqués d’une icône sont téléchargeables" className="mb-3"/>
                      <GIEList data={this.state.data} type="workOrder" noData="Vous n’avez pas d'intervention à consulter"/>
                  </div>
              </GIEServicesContainer>
          </div>
        );
    }
}
